import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

// Components
import { Spin, Modal, Form, Row, Col, Alert, Radio, DatePicker } from 'antd';

// Selectors
import { getMonitoringVisiblePeriod } from '../../data/app/selector';

// Actions

// Constants
import { MODAL_SIZES } from '../../constants/modal';

import { periods } from '../../utils';
import moment from 'moment';

class PeriodSelectModal extends PureComponent {

    constructor(props){
        super(props);
        this.state = {
            period0: false,
            durationError: undefined
        };
    }

    componentDidMount() {
        const { period } = this.props;
        this.setState({
            period0: period.get('period') === 0
        });
    }

    getValuesForToday = () => {
        const today = new Date();
        today.setHours(0,0,0);

        const from = today.getTime();
        const to = 0;

        return {period: periods.today, from, to};
    }

    getValuesForYesterday = () => {
        let today = new Date();
        const yesterdayDate = today.getDate() - 1;

        const yesterday = new Date(today.setDate(yesterdayDate));
        yesterday.setHours(0,0,0);

        today = new Date();
        today.setHours(0,0,0);

        const from = yesterday.getTime();
        const to = today.getTime();

        return {period: periods.yesterday, from, to};
    }

    getValuesForThisWeek = () => {
        const today = new Date();
        const first = today.getDate() - today.getDay() + 1;

        const monday = new Date(today.setDate(first));
        monday.setHours(0,0,0);

        const from = monday.getTime();
        const to = 0;

        return {period: periods.thisWeek, from, to};
    }

    getValuesForLastWeek = () => {
        const today = new Date();
        const sunday = new Date();
        const first = today.getDate() - (7 + today.getDay()) + 1;
        const last = today.getDate() - today.getDay() + 1;

        const lastMonday = new Date(today.setDate(first));
        lastMonday.setHours(0,0,0);

        const lastSunday = new Date(sunday.setDate(last));
        lastSunday.setHours(0,0,0);

        const from = lastMonday.getTime();
        const to = lastSunday.getTime();

        return {period: periods.lastWeek, from, to};
    }

    getValuesForThisMonth = () => {
        const firstDay = new Date();
        firstDay.setDate(1);
        firstDay.setHours(0,0,0);

        const from = firstDay.getTime();
        const to = 0;

        return {period: periods.thisMonth, from, to};
    }

    getValuesForLastMonth = () => {
        const date = new Date();
        const firstDay = new Date(date.getFullYear(), date.getMonth() - 1, 1);
        firstDay.setHours(0,0,0)

        const lastDay = new Date();
        lastDay.setDate(1);
        lastDay.setHours(0,0,0);

        const from = firstDay.getTime();
        const to = lastDay.getTime();

        return {period: periods.lastMonth, from, to};
    }

    getValuesForThisQuarter = () => {
        const date = new Date();
        const quarter = Math.floor(date.getMonth() / 3 + 1);
        const firstMonth = 1 + ((quarter - 1) * 3);

        const firstDay = new Date(date.getFullYear(), firstMonth - 1, 1);
        firstDay.setHours(0,0,0);

        const from = firstDay.getTime();
        const to = 0;

        return {period: periods.thisQuarter, from, to};
    }

    getValuesForLastQuarter = () => {

        const dateLastQuarter = new Date();
        const lastQuarter = Math.floor(dateLastQuarter.getMonth() / 3);
        const firstMonthLastQuarter = 1 + ((lastQuarter - 1) * 3);

        const firstDay = new Date(dateLastQuarter.getFullYear(), firstMonthLastQuarter - 1, 1);
        firstDay.setHours(0,0,0);

        const date = new Date();
        const quarter = Math.floor(date.getMonth() / 3 + 1);
        const firstMonth = 1 + ((quarter - 1) * 3);

        const lastDay = new Date(date.getFullYear(), firstMonth - 1, 1);
        lastDay.setHours(0,0,0);

        const from = firstDay.getTime();
        const to = lastDay.getTime();

        return {period: periods.lastQuarter, from, to};
    }

    getValuesForThisYear = () => {
        const date = new Date();

        const firstDay = new Date(date.getFullYear(), 0, 1);
        firstDay.setHours(0,0,0);

        const from = firstDay.getTime();
        const to = 0;

        return {period: periods.thisYear, from, to};
    }

    getValuesForLastYear = () => {
        const date = new Date();

        const lastDay = new Date(date.getFullYear(), 0, 1);
        lastDay.setHours(0,0,0);

        const firstDay = new Date(date.getFullYear() - 1, 0, 1);
        lastDay.setHours(0,0,0);

        const from = firstDay.getTime();
        const to = lastDay.getTime();

        return {period: periods.lastYear, from, to};
    }

    handleSubmit = () => {
        const { form, onSave, msgs } = this.props;
        let durationError = '';

        form.validateFields((err, values) => {

            let difference;
            let differenceDays;

            switch(values.period) {
                case 0 :
                    difference = values.to - values.from;
                    differenceDays = difference / (1000 * 3600 * 24);
                    if (differenceDays > 365) {
                        // eslint-disable-next-line prefer-destructuring
                        durationError = msgs.training.durationError;
                        // window.alert(durationError);
                        this.setState({durationError});
                        return;
                    }
                    break;
                case periods.today:
                    onSave(this.getValuesForToday());
                    return;
                case periods.yesterday:
                    onSave(this.getValuesForYesterday());
                    return;
                case periods.thisWeek:
                    onSave(this.getValuesForThisWeek());
                    return;
                case periods.lastWeek:
                    onSave(this.getValuesForLastWeek());
                    return;
                case periods.thisMonth:
                    onSave(this.getValuesForThisMonth());
                    return;
                case periods.lastMonth:
                    onSave(this.getValuesForLastMonth());
                    return;
                case periods.thisQuarter:
                    onSave(this.getValuesForThisQuarter());
                    return;
                case periods.lastQuarter:
                    onSave(this.getValuesForLastQuarter());
                    return;
                case periods.thisYear:
                    onSave(this.getValuesForThisYear());
                    return;
                case periods.lastYear:
                    onSave(this.getValuesForLastYear());
                    return;
                default:
                    break;
            }

            if (err) {
                return;
            }
            this.setState({durationError});
            onSave(values);
        });
    };

    handleAlertClose = () => {
        const { form } = this.props;
        form.setFields({
            hasError: {
                value: undefined
            }
        });
    };

    render() {
        const {
            form,
            isShown,
            isLoading = false,
            msgs,
            onCancel,
            period,
            isMobile
        } = this.props;

        const {
            period0,
            durationError
        } = this.state;

        const { getFieldValue, getFieldDecorator } = form;

        const radioStyle = isMobile ? {display: 'block', height: '20px', lineHeight: '20px'}
        : {display: 'block', height: '30px', lineHeight: '30px'};

        return (
            <Modal
                key="users-modal-change-event"
                visible={isShown}
                confirmLoading={isLoading}
                width={MODAL_SIZES.MEDIUM}
                title={msgs.training.selectPeriod}
                onCancel={onCancel}
                onOk={this.handleSubmit}
                cancelText={msgs.cancel}
                okText={msgs.save}
            >
                <Spin spinning={isLoading} size="large">
                    <Form>
                        {getFieldValue('hasError') && (
                            <Row>
                                <Col xs={24}>
                                    <Alert
                                        message={getFieldValue('hasError')}
                                        type="error"
                                        showIcon
                                        closable
                                        onClose={this.handleAlertClose}
                                    />
                                </Col>
                            </Row>
                        )}

                        <Row gutter={8}>
                            <Col xs={24}>
                                <Form.Item>
                                    {getFieldDecorator('period', {
                                        initialValue: period.get('period'),
                                        rules: [{ required: true, message: msgs.requiredField }]
                                    })(
                                        <Radio.Group buttonStyle="solid" onChange={item => this.setState({period0: item.target.value === 0})}>
                                            <div style={{width: "100%", display:"flex"}}>
                                                <div style={{display:"flex", flexDirection: "column"}}>
                                                    <Radio style={radioStyle} value={2}>{msgs.training.last2min}</Radio>
                                                    <Radio style={radioStyle} value={5}>{msgs.training.last5min}</Radio>
                                                    <Radio style={radioStyle} value={10}>{msgs.training.last10min}</Radio>
                                                    <Radio style={radioStyle} value={30}>{msgs.training.last30min}</Radio>
                                                    <Radio style={radioStyle} value={60}>{msgs.training.last1hour}</Radio>
                                                    <Radio style={radioStyle} value={180}>{msgs.training.last3hours}</Radio>
                                                    <Radio style={radioStyle} value={360}>{msgs.training.last6hours}</Radio>
                                                    <Radio style={radioStyle} value={720}>{msgs.training.last12hours}</Radio>
                                                    <Radio style={radioStyle} value={1440}>{msgs.training.last24hours}</Radio>
                                                    <Radio style={radioStyle} value={0}>{msgs.training.otherPeriod}</Radio>
                                                </div>
                                                <div style={{display:"flex", flexDirection: "column", marginLeft: isMobile ? 20 : 140}}>
                                                    <Radio style={radioStyle} value={periods.today}>{msgs.training.today}</Radio>
                                                    <Radio style={radioStyle} value={periods.yesterday}>{msgs.training.yesterday}</Radio>
                                                    <Radio style={radioStyle} value={periods.thisWeek}>{msgs.training.thisWeek}</Radio>
                                                    <Radio style={radioStyle} value={periods.lastWeek}>{msgs.training.lastWeek}</Radio>
                                                    <Radio style={radioStyle} value={periods.thisMonth}>{msgs.training.thisMonth}</Radio>
                                                    <Radio style={radioStyle} value={periods.lastMonth}>{msgs.training.lastMonth}</Radio>
                                                    <Radio style={radioStyle} value={periods.thisQuarter}>{msgs.training.thisQuarter}</Radio>
                                                    <Radio style={radioStyle} value={periods.lastQuarter}>{msgs.training.lastQuarter}</Radio>
                                                    <Radio style={radioStyle} value={periods.thisYear}>{msgs.training.thisYear}</Radio>
                                                    <Radio style={radioStyle} value={periods.lastYear}>{msgs.training.lastYear}</Radio>
                                                </div>
                                            </div>
                                        </Radio.Group>
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                        {
                            period0 &&
                            <div>
                                <Row gutter={[1, 1]}>
                                    <Col span={4}>{msgs.training.from}:</Col>
                                    <Col span={20}>
                                        <Form.Item>
                                            {getFieldDecorator('from', {
                                                initialValue: moment().subtract(1, 'days').startOf('day'),
                                                rules: [{ required: true, message: msgs.requiredField }]
                                            })(
                                                <DatePicker showTime />
                                            )}
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={[1, 1]}>
                                    <Col span={4}>{msgs.training.to}:</Col>
                                    <Col span={20}>
                                        <Form.Item>
                                            {getFieldDecorator('to', {
                                                initialValue: moment().subtract(1, 'days').endOf('day'),
                                                rules: [{ required: true, message: msgs.requiredField }]
                                            })(
                                                <DatePicker showTime />
                                            )}
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={[1, 1]}>
                                    <Col span={4}>{}</Col>
                                    <Col span={20}>
                                        <Form.Item>
                                            <span style={{ color: "red" }}>{durationError}</span>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </div>
                        }
                    </Form>
                </Spin>
            </Modal>
        );
    }
}

export default connect(
    (state, ownProps) => ({
        ...ownProps,
        period: getMonitoringVisiblePeriod(state)
    }),
    {}
)(Form.create()(PeriodSelectModal));
